import React, { useState, useEffect, useContext } from 'react';
import { Button } from '../components/ui/button';
import axios from 'axios';
import { AuthContext } from '../lib/AuthContext';

const ExpertServices = () => {
  const [showForm, setShowForm] = useState(false);
  const [services, setServices] = useState([]);
  const [form, setForm] = useState({
    name: '',
    price: '',
    duration: '',
    description: ''
  });
  const { accessToken } = useContext(AuthContext);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axios.get('https://quirkleai.com/api/services/', {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });
      setServices(response.data);
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAddService = async () => {
    if (!form.name || !form.price || !form.duration) {
      alert("Fill all required fields");
      return;
    }
    try {
      await axios.post('https://quirkleai.com/api/services/', form, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });
      setForm({ name: '', price: '', duration: '', description: '' });
      setShowForm(false);
      fetchServices();
    } catch (error) {
      console.error('Error adding service:', error);
    }
  };

  const handleDeleteService = async (id) => {
    try {
      await axios.delete(`https://quirkleai.com/api/services/${id}/`, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });
      fetchServices();
    } catch (error) {
      console.error('Error deleting service:', error);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-800">Your Services</h1>
        <Button onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ Add New Service'}
        </Button>
      </div>

      {showForm && (
        <div className="border p-4 rounded-md bg-white space-y-4 shadow-sm">
          <div className="grid gap-4 md:grid-cols-2">
            <input
              name="name"
              placeholder="Service name *"
              className="border rounded p-2 w-full"
              value={form.name}
              onChange={handleChange}
            />
            <input
              name="price"
              placeholder="Price in ₹ *"
              className="border rounded p-2 w-full"
              value={form.price}
              onChange={handleChange}
            />
            <input
              name="duration"
              placeholder="Duration (e.g. 30 min) *"
              className="border rounded p-2 w-full"
              value={form.duration}
              onChange={handleChange}
            />
            <input
              name="description"
              placeholder="Short description"
              className="border rounded p-2 w-full"
              value={form.description}
              onChange={handleChange}
            />
          </div>
          <Button className="mt-2" onClick={handleAddService}>Save Service</Button>
        </div>
      )}

      {services.length === 0 ? (
        <p className="text-gray-500">No services added yet.</p>
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {services.map((s) => (
            <div key={s.id} className="border rounded-lg p-4 shadow-sm bg-white">
              <h2 className="text-lg font-semibold">{s.name}</h2>
              <p className="text-sm text-gray-500 mb-1">{s.description}</p>
              <p className="text-sm font-medium">💸 ₹{s.price} • ⏱ {s.duration}</p>
              <div className="flex gap-2 mt-3">
                <Button size="sm" variant="outline">Edit</Button>
                <Button size="sm" variant="destructive" onClick={() => handleDeleteService(s.id)}>Delete</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExpertServices;
